import { IThemeProps } from "./IThemeProps";

const dark: IThemeProps = {
  colors: {
    primary: '#79ffb8',
    secondary: '#79ffb8',
    tertiary: '#79ffb8',
    success: '',
    danger: '#d94545',
    pink: '#fe157e',
    warning: '',
    info: '#52da59',
    light: '',
    dark: '#3d3d3d',
    white: '#ffffff',
    muted: '#bed0de',
    gray: '#bed0de',
    whiteGray: '#ffffffa8',
    purple: '#72169b',
  },
  gradients: {
    primary: '#ffffff1f', // não mexer
    secondary: 'linear-gradient(-180deg, #22c7a5 0%, #01b590 50%)',
    tertiary: 'linear-gradient(-180deg, #052421 0%, #01b590 50%)',
    rankingGradient: 'radial-gradient(circle,#ffffff4a  0%, #ffffff00 100%)',
  },
  radius: {
    primary: '24px',
    secondary: '12px',
  },
  header: {
    header: '#162036',
    subHeader: '#101426',
    gradient: 'linear-gradient(220deg, #72169b, #480c62)',
    border: '#1fb3971f',
    inputSearch: '#162036',
    inputSearchBorder: '#c3b8b817',
  },
  menu: {
    buttonBackground: 'transparent',
    buttonColor: '#fff',
    buttonShadow: 'none',
    buttonShadowHover: '#03bb85',
  },
  dropDownMenu: {
    background: 'linear-gradient(220deg, #26375c, #101425)',
    border: 'none',
  },
  cards: {
    primary: '#162036',
    secondary: '#182e12',
    tertiary: '#f4fffd0f',
    backgroundSpinner: '#00897580',
    backdropFilter: 'blur(35px) saturate(115%)',
    border: '#c3b8b817',
    modal: '#06242270',
  },
  modal: {
    background: '#0d1020',
    border: '#bed0de20',
    closeButton: '#bed0de',
  },
  background: {
    primary: 'rgb(28 108 100 / 15%)',
    secondary: '#182e12',
    tertiary: '#009576', 
  },
  shadows: {
    primary: 'none',
  },
  input: {
    background: '#162036',
    border: '#bed0de50',
    borderActive: '#bed0de50',
    labelColor: '#79ffb8',
  },
  specific: {
    menuTitles: '#79ffb8',
    menuBorder: 'none',
    menuButton: '#ffffff',
    menuDropDownAvatarButtonOnHover: '#ffffff0f',
    menuButtonTriggerBorder: 'transparent',
    cardGradient3D: 'linear-gradient(180deg, #008570 0%,transparent 125%)',
    cardGradientShadow: '0px 0px 70px #11111140',
    inputSearchHeaderBg: '#162036',
    loaderBg: 'radial-gradient(#17b585 0,transparent 100%)',
    clockDown: '#162036',
    asideModule: '#162036',
    footerModule: '#162036',
    cardDashedBorder: '#ffffff4a',
    cardCommunity: '#162036',
    svgFilterRecolor: 'invert(94%) sepia(60%) saturate(681%) hue-rotate(69deg) brightness(100%) contrast(92%)',
    avatarBorderColor: '#162036',
    verifyBorderAnimationColor: '#ffffff20',
    wysiwygButtons: '#79ffb8',
  }
}

export default dark;
